import { preload } from "../include/module";
import { showContents } from "../include/module";
import { anchorLink } from "../include/module";
import { toggleHeader } from "../include/module";
import { pageTop } from "../include/module";
import { showMovie } from "../include/module";
import { navCurrent } from "../include/module";





(() => {

  preload();
  showContents();
  anchorLink();
  toggleHeader();
  pageTop();
  showMovie();
  navCurrent();

})();



// WEBPACK FOOTER //
// ./src/assets/js/movie/script.js